import React from 'react';

/**
 * The lightbox's way back to its plan card, for the real pages inside it. A
 * context, not a prop, since the pages are rendered as route elements. Set only
 * for the "Compare plans" entry; undefined leaves the full-page picker unchanged.
 */
export const QuickPayBackContext = React.createContext<
  (() => void) | undefined
>(undefined);

export const useQuickPayBack = () => React.useContext(QuickPayBackContext);
